import { Firebase } from "./firebase";

export default Firebase;
